module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ApzC48/images/cover.jpg?1703000716470",
      "alt": "This image is the cover for the book Japan's Pacific War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Japan's Pacific War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("‘I had no qualms fighting the Australians, just as I have killed without remorse any of the Emperor’s enemies: the British, the Americans and the Dutch’, so admits Takahiro Sato in this ground-breaking oral history of Japan’s Pacific War.  Thanks to years of research and over 100 interviews with veterans, the Author has compiled a fascinating collection of personal accounts by former Japanese soldiers, sailors and airmen.  Their candid views are often provocative and shocking. There are admissions of brutality, the killing of prisoners and cannibalism. Stark descriptions of appalling conditions and bitter fighting blend with descriptions of family life. Their views on the prowess of the enemy differ with some like air ace Kazuo Tsunoda who believed the Australians ‘worthy’. Some remain unrepentant while others such as Hideo Abe are ashamed of his part in Japan’s war of aggression.  The result is a revealing insight into the minds of a ruthless and formidable enemy which provides the reader with a fresh perspective on the Second World War.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Peter Williams was born in Hobart, Tasmania, where he was educated at St Virgil's College. After ten years living in Europe, North America and Japan he became a history teacher at Darwin, in Australia's Northern Territory. There he also worked for the Darwin Military Museum and published his first book, The Battle of Anzac Ridge, on the Gallipoli landing. His PhD topic was the 1942 Kokoda Campaign in New Guinea.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0